import React, { useEffect, useState } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { LanguageProvider } from './context/LanguageContext';

import ModernNavbar from './components/ModernNavbar';
import EnhancedFooter from './components/EnhancedFooter';
import ModernHomePage from './pages/ModernHomePage';
import EnhancedAboutPage from './pages/EnhancedAboutPage';
import ServicesPage from './pages/ServicesPage';
import ProductsPage from './pages/ProductsPage';
import ProjectsPage from './pages/ProjectsPage';
import ContactPage from './pages/ContactPage';

import './styles/modern.css';
import './styles/responsive.css';
import './styles/mobile-fixes.css';
import './styles/enhanced-mobile.css';
import './styles/mobile-header-fix.css';
import './styles/mobile-footer-fix.css';
import './styles/section-alternation.css';
import './styles/enhanced-hero-mobile.css';
import './styles/section-title-fix.css';
import './styles/mobile-enhancements.css';
import './styles/hero-mobile-fix.css';
import './styles/mobile-polish.css';
import './styles/professional-mobile.css';

// Composant pour suivre le changement de route
const RouteTracker = ({ setCurrentPage }) => {
  const location = useLocation();
  
  useEffect(() => {
    // Déterminer la page actuelle en fonction de l'URL
    const path = location.pathname;
    if (path === '/') {
      setCurrentPage('home');
    } else if (path === '/about') {
      setCurrentPage('about');
    } else if (path === '/services') {
      setCurrentPage('services');
    } else if (path === '/products') {
      setCurrentPage('products');
    } else if (path === '/projects') {
      setCurrentPage('projects');
    } else if (path === '/contact') {
      setCurrentPage('contact');
    } else {
      setCurrentPage('home');
    }
    
    // Faire défiler vers le haut lors du changement de page
    window.scrollTo(0, 0);
  }, [location, setCurrentPage]);
  
  return null;
};

function AppContent() {
  const [currentPage, setCurrentPage] = useState('home');
  
  return (
    <div className="flex flex-col min-h-screen">
      <RouteTracker setCurrentPage={setCurrentPage} />
      <ModernNavbar />
      <main className="flex-grow">
        <Routes>
          <Route path="/" element={<ModernHomePage />} />
          <Route path="/about" element={<EnhancedAboutPage />} />
          <Route path="/services" element={<ServicesPage />} />
          <Route path="/products" element={<ProductsPage />} />
          <Route path="/projects" element={<ProjectsPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="*" element={<ModernHomePage />} />
        </Routes>
      </main>
      <EnhancedFooter pageType={currentPage} />
    </div>
  );
}

function App() {
  return (
    <LanguageProvider>
      <BrowserRouter>
        <AppContent />
      </BrowserRouter>
    </LanguageProvider>
  );
}

export default App;